import React, { useEffect, useRef, useState } from 'react';
import { api } from 'src/shared/api';
import { useDebounce } from 'use-debounce';

import styles from './places-input.module.css';

interface IPlacesInput {
  defaultValue: string;
  setValue: (value: string | null) => void;
  inputStyles?: React.CSSProperties;
  listStyles?: React.CSSProperties;
}
const PlacesInput = ({ defaultValue, setValue, inputStyles, listStyles }: IPlacesInput) => {
  const input = useRef<HTMLInputElement | null>(null);

  const [userPlace, setUserPlace] = useState<string | null | undefined>(null);
  const [searchResults, setSearchResults] = useState<string[]>([]);
  const [debouncedUserPlace] = useDebounce(userPlace, 500);

  const handleChange = () => {
    setValue(null);
    setUserPlace(input.current?.value);
  };

  useEffect(() => {
    if (debouncedUserPlace) {
      api.getGeoVariants(debouncedUserPlace).then((locations) => {
        setSearchResults(locations.map((el) => el.address));
      });
    } else {
      setSearchResults([]);
    }
  }, [debouncedUserPlace]);

  const handlePlaceClick = (place: string) => {
    if (input.current) {
      input.current.value = place;
    }
    setUserPlace(null);
    setSearchResults([]);
    setValue(place);
  };

  return (
    <div className={styles.input_container}>
      <input
        ref={input}
        type="text"
        name="place"
        required
        className={styles.input_place}
        defaultValue={defaultValue || ''}
        onChange={() => handleChange()}
        style={inputStyles}
      />
      {searchResults.length > 0 && (
        <ul className={styles.places_list} style={listStyles}>
          {searchResults.map((place, idx) => (
            <li key={idx} onClick={() => handlePlaceClick(place)}>
              {place}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export { PlacesInput };
